<template>
    <div>
        <div>
            <button id="myBtn" type="button" class="sp-button-sm" @click="openModal('setShopTogetherModal')">Share on Shop Together</button>
        </div>
        <!-- The Modals -->
        <div id="setShopTogetherModal" class="modal" style="top:5em; padding:1em; width:97%;">
            <!-- Modal content -->
            <div class="modal-content">
                <a @click="closeModal('setShopTogetherModal')" style="color: inherit;"><span class="close">&times;</span></a>
                <div class="card" :key="shopTogetherAlertKey">
                    <h5 style="color:#ff5566; padding-left:0.7em;">Share with</h5>
                    <div class="card card-flat-pad" v-for="(shp,shpindex) in shop_together_activities" :key="shpindex">
                        <div style="float:right;">
                            <p v-if="(shp.data_shared && (shp.data_shared != ''))" class="sp-app-default-color" style="font-size:12px;">{{shp.data_shared}}</p>
                            <button v-else id="myBtn" type="button" class="btn sp-button-sm" style="background:#fc4112 !important; color:#ffffff !important;" @click="showShareOnShopTogether('S2G'+shpindex)"><i class="fa fa-share-alt"></i> Share</button>
                        </div>
                        <ul style="clear:both">
                            <li v-for="(u,uindex) in shp.activity_users" :key="uindex" style="display:inline-block; margin-left:1em; text-align:center;">
                            <div class="avatar">
                                <img src="/static/assets/images/dummy-image.png" width="30" height="30" style="border-radius: 50%;"/>
                            </div>
                            <span class="sp-app-default-color" style="font-size:12px;">
                                <span v-if="user.user_id == u.activity_user">You</span>
                                <span v-else>{{u.activity_user_fullname}}</span>
                            </span>
                            </li>
                        </ul>
                        <ul :id="'S2G'+shpindex" style="display:none">
                            <li style="display:inline-block;"><input type="text" class="form-control" v-model="shp.data_caption" placeholder="Say something about this"/></li>
                            <li style="display:inline-block;">
                                <button id="myBtn" type="button" class="btn sp-button-sm" style="background:#fc4112 !important; color:#ffffff !important;" @click="shareOnShopTogether(shp,shpindex)"><i class="fa fa-share-alt"></i></button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import services from './../../services/service'; // Service Class
import PostsCo from './../mixins/postsco/index.vue';
import Preset from './../../resources/preset.js';
let service = new services();

export default {
    name: 'ShopTogetherWidget',
    props: {
        currentActivity:Object,
    },
    mixins: [Preset,PostsCo],
    data () {
      return {
        shop_together_activities:{},
        // user:{},
        // currentActivity:{},
        shopTogetherAlertKey:0,
      }
  },

    methods: {
        openModal(id) {
            document.getElementById(id).style.display = "block";
        },

        closeModal(id) {
            document.getElementById(id).style.display = "none";
        },

        // preset() { //recheck do login ifelse
        //     let self = this;
        //     localforage.getItem(service.udb_name, function(err, value) { //quick with the callback version
        //         if(value != undefined) {
        //             self.user.user_id = value.user_id;
        //             self.user.user_name = value.user_name;
        //         }else {
        //             self.$router.push('login');
        //         }
        //     });
        // },

        getShopTogetherActivities(){
            let self = this;
            localforage.getItem(service.s2gdb_name, function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.shop_together_activities = value;
                }
            });
        },

        showShareOnShopTogether(id){
            document.getElementById(id).style.display = "block";
        },

        shareOnShopTogether(activity,index){
            this.setShopTogetherActivities(activity,index)
            // let self = this;
            // localforage.getItem(service.current_s2g_activity_db_name, function(err, value) { //quick with the callback version
            //     if(value != undefined) {
            //         self.currentActivity = value;
            //         self.setShopTogetherActivities(activity,index);
            //     }
                
            // });
        },

        setShopTogetherActivities(activity,index){
           if((this.currentActivity.data_module && (this.currentActivity.data_module > 0)) && (this.currentActivity.data_module_id && (this.currentActivity.data_module_id > 0))){
                var payload = {
                    activity_user: this.user.user_id,
                    activity_activity: activity.activity_id,
                    activity_action_type: 48,//post activity
                    activity_module: this.currentActivity.data_module,
                    activity_module_id: this.currentActivity.data_module_id,
                    activity_caption: activity.data_caption || '',
                }
                service.setActivity(this, payload).then(response => {
                    if(response.body.status == 201) {
                       //show as shared
                       this.shop_together_activities[index].data_shared = 'Shared';
                       this.shopTogetherAlertKey++;
                       //or go to shop together
                       //.
                       //add to chats
                       //---set Chat params
                       //-----set chatter
                        let chatter_set = {
                           chatter_chat_from_module: 1,//user
                           chatter_chat_from: this.user.user_id,
                           chatter_chat_to_module: 20, //group
                           chatter_chat_to: 16,//group id
                           chatter_chat_group: 16,
                        }
                        let chat_set = {
                           chat_set_message: activity.data_caption,//use activity.data_caption
                           chat_message_type: 8, //object product
                           chat_message_object: this.currentActivity.data_module_id, //
                           chat_message_object_name: this.currentActivity.data_module_name,//
                           chat_message_object_price: this.currentActivity.data_module_price,//
                           chat_message_object_url: this.currentActivity.data_module_url,//
                           chat_message_object_media: this.currentActivity.data_module_media,
                        }
                        //---post chat
                        this.chat_callPostChat(chatter_set,chat_set);
                    }
                }).catch((err) => {})
            }
        },
     
    },
    created: function(){
        //this.preset();
        this.getShopTogetherActivities();
    }
}
</script>


// WEBPACK FOOTER //
// activeshoptogether.vue?944a4aca